/*
 * @Author: wangxiang 
 * @Date: 2019-11-11 13:42:36 
 * @Last Modified by: wangxiang
 * @Last Modified time: 2019-11-24 14:19:45
 */
import Vue from 'vue';
const DESIGN_DRAFT_WIDTH = 375;

export function getEditorConfigForEditingElement (elementName) {
  const Ctor = Vue.component(elementName);

  // 直接 return new Ctor() 并将其赋值给 vuex 的 state 会报错：Cannot convert a Symbol value to a string
  return new Ctor().$options.editorConfig;
}

export function swapZindex (x, y) {
  const tmp = y[styleKey].zindex;

  y[styleKey].zindex = x[styleKey].zindex;
  x[styleKey].zindex = tmp;
}

/**
 * 将 px 转换为 rem
 * @param {Number} px
 */
function _px2Rem(px) {
  const number = Math.pow(10, 6);
  const val = (px / (DESIGN_DRAFT_WIDTH / 10)) * number;
  const rem = Math.round(val) / number + 'rem';

  return rem;
}

/**
 * 支持百分数表示的数值
 * @param {Number} px 元素的某个属性的像素值，比如 height
 * @param {Boolean} isToRem 是否将 px 转换为 rem
 */
export function parsePx (px, isToRem = false) {
  if (typeof px === 'string') {
    return px;
  }
  if (isToRem) return _px2Rem(px);
  return `${px}px`;
}

/**
 * 生成uuid
 */
export const genUUID = () => {
  return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
}



// WEBPACK FOOTER //
// ./src/core/element.js